/**
 * Scroll-Hinweis (Stylebook P8) — App-Variante. In der App scrollt das ganze
 * Fenster (html/body/#app: height 100%, .app-main wächst), NICHT ein innerer
 * Container. Darum messen wir den Dokument-Scroll.
 *
 * Zeigt zwei wippende Pfeile, solange (a) der Nutzer noch ~am Anfang ist
 * (scrollTop < 24) UND (b) darunter noch > 60px Inhalt liegt. Verschwindet beim
 * ersten Scrollen. Da der Lesetext nachstreamt (Höhe wächst), wird die Sichtbarkeit
 * ein paar Sekunden nachberechnet. `resetKey` (Kapitel/Modus) startet das neu.
 */
import { useEffect, useState } from "preact/hooks";

function scroller(): HTMLElement {
  return (document.scrollingElement as HTMLElement) || document.documentElement;
}

export function useScrollHint(resetKey: unknown): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let scrolledAway = false;
    const compute = () => {
      if (scrolledAway) return;
      const el = scroller();
      const moreBelow = el.scrollHeight - el.clientHeight - el.scrollTop > 60;
      setShow(el.scrollTop < 24 && moreBelow);
    };
    const onScroll = () => {
      if (scroller().scrollTop > 24) {
        scrolledAway = true;
        setShow(false);
      } else {
        compute();
      }
    };

    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("resize", compute, { passive: true });
    // Inhalt streamt nach → Höhe wächst; ein paar Sekunden nachberechnen.
    compute();
    const iv = setInterval(compute, 300);
    const stop = setTimeout(() => clearInterval(iv), 5000);

    return () => {
      removeEventListener("scroll", onScroll);
      removeEventListener("resize", compute);
      clearInterval(iv);
      clearTimeout(stop);
    };
  }, [resetKey]);

  return show;
}
